import React from 'react'
import classNames from 'classnames'
import { useUniqueIds } from '../../utilities/general'
import Container from '../container'
import Row from '../row'
import Col from '../col'
import StatBox from '../stat-box'
import styles from './stat-boxes.module.scss'
import shared from '../shared.module.scss'

const StatBoxesSlice = ({ slice }) => {
  const {
    stat_boxes_per_row,
    stat_boxes_margin_bottom,
    stat_boxes_text_color,
    stat_boxes_background_color,
  } = slice.primary

  const { items } = slice

  const colWidths = {
    auto: 'auto',
    1: 12,
    2: 6,
    3: 4,
    4: 3,
    6: 2,
    12: 1,
  }

  const itemsWithIds = useUniqueIds( items )

  return (
    <section
      className={ classNames( styles.section, {
        [ shared.margin ]: stat_boxes_margin_bottom,
        [ shared.padding ]: stat_boxes_background_color,
      })}
      style={{
        color: stat_boxes_text_color,
        backgroundColor: stat_boxes_background_color
      }}
    >
      <Container>
        <Row gutter={{ base: '3rem', md: '3rem', lg: '5rem' }}>
          { !! itemsWithIds.length && itemsWithIds.map( item => (
            <Col key={ item.uniqueId } span={ 12 } md={ colWidths[ stat_boxes_per_row ] } lg={ colWidths[ stat_boxes_per_row ] }>
              <StatBox
                className={ styles.box }
                stat={ item.stat_boxes_stat }
                text={ item.stat_boxes_text }
              />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export default StatBoxesSlice